.eyebrow {
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.06em;
    color: var(--mantine-color-dimmed);
}

.scheduleRow {
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-xl);
    align-items: flex-end;
}

.scheduleField {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.scheduleDivider {
    align-self: stretch;
    width: 1px;
    margin: 4px 0;
    background-color: var(--mantine-color-gray-2);
}

.fieldTag {
    padding: 2px 6px;
    border-radius: var(--mantine-radius-sm);
    background-color: var(--mantine-color-gray-1);
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--mantine-color-gray-6);
}

.patternGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: var(--mantine-spacing-md);
}

/* Card visuals live on the inner element: Mantine's UnstyledButton styles are
   loaded after this module and would otherwise win on the button itself. */
.patternCardInner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--mantine-spacing-xs);
    min-height: 100%;
    padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-body);
    text-align: left;
    transition:
        border-color 120ms ease,
        background-color 120ms ease;
}

.patternCard:hover:not(:disabled):not([data-checked]) .patternCardInner {
    background-color: var(--mantine-color-gray-0);
}

.patternCard[data-checked] .patternCardInner {
    border-color: var(--mantine-color-blue-5);
    background-color: var(--mantine-color-blue-0);
    box-shadow: inset 0 0 0 1px var(--mantine-color-blue-5);
}

.patternCard:disabled .patternCardInner {
    opacity: 0.6;
}

.patternTitle {
    font-size: var(--mantine-font-size-lg);
    font-weight: 700;
}

.patternCard[data-checked] .patternTitle {
    color: var(--mantine-color-blue-7);
}

.patternDescription {
    font-size: var(--mantine-font-size-sm);
    line-height: 1.45;
    color: var(--mantine-color-dimmed);
}

.patternDiagram {
    display: flex;
    align-items: center;
    align-self: stretch;
    margin-top: auto;
    padding: var(--mantine-spacing-xs) 0;
}

.patternDot {
    flex: 0 0 auto;
    width: 14px;
    height: 14px;
    border-radius: 50%;
}

.patternDotSmall {
    width: 9px;
    height: 9px;
}

.patternLine {
    flex: 1 1 auto;
    min-width: 8px;
    height: 2px;
    background-color: var(--mantine-color-gray-3);
}

.patternCount {
    padding: 2px 8px;
    border-radius: var(--mantine-radius-sm);
    background-color: var(--mantine-color-gray-1);
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    color: var(--mantine-color-gray-7);
}

.patternCard[data-checked] .patternCount {
    background-color: var(--mantine-color-blue-1);
    color: var(--mantine-color-blue-8);
}

.cadenceBar {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-md);
    flex-wrap: wrap;
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    background-color: var(--mantine-color-violet-0);
    border: 1px solid var(--mantine-color-violet-1);
    border-radius: var(--mantine-radius-md);
}

.cadenceIcon {
    display: flex;
    color: var(--mantine-color-violet-6);
}

.cadenceSummary {
    margin-left: auto;
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
    color: var(--mantine-color-violet-7);
}

.weekdayGroup {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.weekday {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-gray-0);
    color: var(--mantine-color-gray-6);
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
    cursor: pointer;
    transition:
        background-color 120ms ease,
        color 120ms ease,
        border-color 120ms ease;
}

.weekday:hover {
    background-color: var(--mantine-color-gray-1);
}

.weekdaySelected {
    background-color: var(--mantine-color-violet-6);
    border-color: var(--mantine-color-violet-6);
    color: var(--mantine-color-white);
}

.weekdaySelected:hover {
    background-color: var(--mantine-color-violet-7);
}

.buildoutHeader {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--mantine-spacing-md);
    flex-wrap: wrap;
}

.jobCard {
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: var(--mantine-radius-md);
    overflow: hidden;
}

/* A skipped visit stays legible enough to un-skip, but reads as inactive. */
.jobSkipped .jobPanel > *:not(.jobSkip),
.jobSkipped .jobReqs {
    opacity: 0.45;
}

.jobGrid {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.jobPanel {
    flex: 0 0 190px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: var(--mantine-spacing-md);
    border-right: 1px solid var(--mantine-color-gray-1);
}

.jobPanelDeploy {
    background-color: var(--mantine-color-blue-0);
}

.jobPanelService {
    background-color: var(--mantine-color-violet-0);
}

.jobPanelPickup {
    background-color: var(--mantine-color-teal-0);
}

.jobLabel {
    font-weight: 700;
}

.jobDate {
    font-size: var(--mantine-font-size-lg);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.01em;
    color: var(--mantine-color-dark-7);
}

.jobSkip {
    margin-top: auto;
    padding-top: var(--mantine-spacing-sm);
}

.jobServiceType {
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    line-height: 1.35;
    color: var(--mantine-color-violet-7);
}

.jobFlag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--mantine-color-violet-6);
}

.jobReqs {
    flex: 1 1 320px;
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-md);
}

.jobNotes {
    padding-bottom: var(--mantine-spacing-sm);
    border-bottom: 1px dashed var(--mantine-color-gray-2);
}

.noteReadOnly {
    padding: 8px 12px;
    border: 1px dashed var(--mantine-color-gray-3);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-gray-0);
    font-size: var(--mantine-font-size-sm);
    line-height: 1.5;
    color: var(--mantine-color-dimmed);
    white-space: pre-wrap;
}

.reqChips {
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-sm);
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: 5px 12px;
    background-color: var(--mantine-color-body);
    border: 1px dashed var(--mantine-color-gray-4);
    border-radius: var(--mantine-radius-xl);
    font-size: var(--mantine-font-size-sm);
}

.chipMuted {
    border-color: var(--mantine-color-violet-2);
    color: var(--mantine-color-dimmed);
}

.chipDot {
    flex: 0 0 auto;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.chipTag {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--mantine-color-gray-5);
}

.templateChip {
    display: inline-flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: 3px 4px 3px 12px;
    background-color: var(--mantine-color-body);
    border: 1px solid var(--mantine-color-violet-2);
    border-radius: var(--mantine-radius-xl);
}

.templateSelect input {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    min-width: 110px;
}

.addChip {
    border-style: dashed;
}

.summary {
    display: flex;
    gap: var(--mantine-spacing-lg);
}

.stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.05;
}

.statValue {
    font-size: 1.9rem;
    font-weight: 700;
}

.statLabel {
    font-size: var(--mantine-font-size-xs);
    color: var(--mantine-color-dimmed);
}
